import { tiktokPixelPurchase } from '../../../api/funnel';

const safeWindow = () => /** @type {any} */ (window);

export const tiktokProvider = {
  name: 'tiktok',

  isAvailable() {
    return Boolean(safeWindow().ttq);
  },

  track(eventName, payload = {}, options = {}) {
    if (!this.isAvailable()) return;
    const { eventId, beOptions = null } = options;
    const eventOptions = eventId ? { event_id: eventId } : {};

    if (process.env.REACT_APP_ENV !== 'production') {
      console.log('[Tracking] TikTok track', eventName, payload, options);
      return;
    }

    if (eventName === 'Lead') {
      safeWindow().ttq.identify({
        email: payload.email,
        external_id: payload.external_id,
      });
    }

    safeWindow().ttq.track(eventName, payload, eventOptions);

    // Keep TikTok Events API call close to TikTok provider logic.
    if (eventName === 'Purchase') {
      tiktokPixelPurchase(beOptions).catch(() => {});
    }
  },
};
